<template>
	<aside
		class="in-article-nav new"
		v-metric="{ module: 'cwnav-art' }"
		v-if="bundle && bundle.assets.length > 0"
	>
		<h3>
			<span>Articles On</span>
			{{ bundle.bundleTitle }}
		</h3>
		<ul>
			<li
				v-for="(item, index) in bundle.assets"
				:key="index"
				:class="{ 'active': isCurrentArticle(item.assetId) }"
			>
				<a
					:href="item.url"
					v-metric="{ link: index + 1 }"
				>
					{{ item.title }}
				</a>
			</li>
		</ul>
	</aside>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

export default {
	created() {
		this.store = useStore(this.$pinia);
	},

	name: 'BundleNav',
	props: {
		currentAssetId: {
			type: String,
			required: true,
		},
	},
	computed: {
		bundle() {
			return this.store.flow.flowInfo.articleBundle || false;
		},
	},
	methods: {
		isCurrentArticle(id) {
			return id === this.currentAssetId;
		},
	},

};
</script>
<style lang="scss">
.in-article-nav {
	h3 span {
		display: block;
		font-size: 1rem;
		font-weight: 400;
	}

	li.active {
		a {
			color: #333132;
			font-weight: 700;

		}

		&::before {
			content: "\25B6";
			font-family: icons, sans-serif;
			font-size: .9375rem;
			margin-left: -.9375rem;
			margin-right: .4375rem;
		}
	}
}
</style>
